export default __webpack_public_path__ + "static/media/3.2e69a274.webp";